const statisticsSi = {
    "user_statistics": "Statistika uporabnikov",
    "menu_item_clicks": "Kliki na elemente menija",
    "statistics": "Statistika",
    "user_traffic": "Uporabniški promet",
    "last_7_days": "Zadnjih 7 dni",
    "last_30_days": "Zadnjih 30 dni",
    "menu_item": "Element menija",
    "click_count": "Število klikov",
    "error_fetching_user_statistics": "Napaka pri pridobivanju statističnih podatkov o uporabnikih.",
    "error_fetching_menu_item_statistics": "Napaka pri pridobivanju statističnih podatkov o elementih menija.",
    "statistics_feature_not_available": "Funkcija statistike je na voljo samo v paketu PRO. Za dostop do te funkcije nadgradite svojo naročnino.",
    "change_subscription_plan": "Spremeni naročniški paket",
    "permission_denied": "Dovoljenje zavrnjeno",
    "error_fetching_rating_statistics": "Napaka pri pridobivanju statističnih podatkov o ocenah.",
    "menu_item_ratings": "Ocene elementov menija",
    "likes": "všečki",
    "dislikes": "ni všeč",
    "rating_trends_last_7_days": "Trendi ocenjevanja (zadnjih 7 dni)",
    "rating_trends_last_30_days": "Trendi ocenjevanja (zadnjih 30 dni)"
};

export default statisticsSi;
